import { computed } from '@ember/object';
import { t as translate } from 'i18n';

/**
 * Makes a translated string computed property. Sample Usages:
 *
 * import t from '@dashboard/i18n/macros/t';
 *
 * title: t('button.ok'),
 * myCountProperty: 2,
 * myProperty: t('widgets.sales.transactions', { count: 'myCountProperty' })
 *
 * First argument is the translation key as a string (not a reference to a property).
 *
 * Second argument is a object that contains property names within a translation string
 * or the count for pluralization:
 * e.g. {{count}} Transactions.
 *
 * This function will resolve the values within the second argument.
 *
 * @param {string} translationKey
 * @param {Object<string, string>} opts
 * @returns {Ember.ComputedProperty}
 */
export default function t(translationKey, opts = {}) {
  const getterKeys = Object.keys(opts).map(propName => opts[propName]);
  return computed(...getterKeys, function () {
    const newOpts = Object.keys(opts).reduce((previous, current) => {
      previous[current] = this.get(opts[current]);
      return previous;
    }, {});
    return translate(translationKey, newOpts);
  });
}